import { LockClosedIcon } from '@radix-ui/react-icons';
import { Box, Card, Flex, Grid, Text, TextField } from '@radix-ui/themes';
import { CollectionMetadata } from '../types';
import { useTranslation } from 'react-i18next';

interface ReadonlyFieldProps {
    label: string;
    value: string;
}

const ReadOnlyField = ({ label, value }: ReadonlyFieldProps) => (
    <Box>
        <Text size='1' color='gray' mb='1' as='div'>
            {label}
        </Text>
        <TextField.Root size='2' value={value} disabled variant='surface' />
    </Box>
);

export const LockedMetadataSection = ({
    proscopeId,
    title,
    credits,
    productionYear,
}: CollectionMetadata) => {
    const { t } = useTranslation('metadataEditor');

    return (
        <Card size={'2'}>
            <Flex justify='between' align='center' mb='3'>
                <Flex align='center' gap='2'>
                    <LockClosedIcon color='var(--orange-9)' />
                    <Text size='2' weight='bold' color='orange'>
                        {t('locked')}
                    </Text>
                </Flex>
                <Text size='1' color='gray'>
                    Source: {t('sources.proscope')}
                </Text>
            </Flex>

            <Grid columns={{ initial: '1', sm: '2' }} gap='4'>
                <ReadOnlyField
                    label={t('fields.proscopeId')}
                    value={proscopeId}
                />
                <ReadOnlyField
                    label={t('fields.originalTitle')}
                    value={title}
                />
                <ReadOnlyField
                    label={t('fields.credits.directors')}
                    value={credits.directors.join(', ')}
                />
                <ReadOnlyField
                    label={t('fields.productionYear')}
                    value={productionYear}
                />
            </Grid>
        </Card>
    );
};
